/** Pure functions for message logic
  */
import { nameAndOrganisation } from "./Attendee";

/** Construct a 1:1 message thread id for the current attendee and another attendee */
export function buildRoomNameForAttendees(me, other, eventId) {
    if (!me || !other) { return null; }

    if (me.id <= other.id) {
        return `e-${eventId}-at-${me.id}-${other.id}`;
    } else {
        return `e-${eventId}-at-${other.id}-${me.id}`;
    }
}


export const buildRoomName = (params) => {
    // event_id is a required parameter
    if (params.meeting_id) {
        return `e-${params.event_id}-mm-${params.meeting_id}`;
        // return `meeting-${params.meeting_id}`;
    } else if (params.appointment_id) {
        return `e-${params.event_id}-ap-${params.appointment_id}`;
        // return `appointment-${params.appointment_id}`;
    }
}


// Extracted from components/message/MessageTitle
export const buildThreadTitle = (thread, me_id, long=false) => {
    console.log(thread);
    if (thread.appointment) {
        return thread.appointment.name;
    } else if (thread.meeting) {
        const tMeeting = thread.meeting;
        if (tMeeting.booker_id == me_id) {
            return `Meeting: ${tMeeting.attendee_name} (${tMeeting.attendee_organisation_name})`;
        } else {
            return `Meeting: ${tMeeting.booker_name} (${tMeeting.booker_organisation_name})`;
        }
    } else { 
        if (thread.sender_id != me_id) {
            if (long) { 
                return nameAndOrganisation(thread.sender); 
            } else {
                return thread.sender.full_name;
            }
        } else {
            if (long) { 
                return nameAndOrganisation(thread.attendee); 
            } else {
                return thread.attendee.full_name;
            }
        }
    }
    // return 'Unknown';
};